<script>
    import {NormalizedCondition} from '@/components/query/adapters/criteria/normalized-criteria';
    import _ from '@/common/helpers';
    import {vIcon} from '@/components/form';

    export default {
        name: 'condition-item-summary',
        props: {
            /**
             * @type {NormalizedCondition}
             */
            condition: NormalizedCondition,
            fieldProvider: Object,
            dividerIcon: {
                type: String,
                default: 'caret-right',
            },
        },
        render(createElement) {
            const particles = this.condition.getSummary(this.fieldProvider);
            const children = [];
            particles.forEach((part) => {
                if (typeof part !== 'string') {
                    const {separate, data, wrap} = part;
                    if (wrap) {
                        children.push(createElement(wrap, {class: 'padding-left-s padding-right-s'}, data));
                    } else if (separate === NormalizedCondition.SummaryBlockTypes.icon) {
                        children.push(this.createIconWrapper(createElement, data));
                    } else {
                        children.push(_.separateArray(data, this.createStrongWrapper(createElement, separate)));
                    }
                } else {
                    children.push(part);
                }
            });
            return createElement('span', children);
        },
        methods: {
            createIconWrapper(createElement, list) {
                return createElement(
                    'span',
                    {class: 'filter-label inline-xs'},
                    _.separateArray(list, createElement(vIcon, {props: {icon: this.dividerIcon}})),
                );
            },
            createStrongWrapper(createElement, word) {
                return createElement(
                    'strong',
                    {class: 'padding-left-s padding-right-s'},
                    word,
                );
            },
        },
    };
</script>
